import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  infoButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    minWidth: "24px",
    height: "16px",
    minHeight: "16px",
    padding: `0 ${designTokens.spacing[1]}`,
    background: "none",
    border: "none",
    cursor: "pointer",
    lineHeight: "1",
    color: designTokens.accent[700],
    borderRadius: designTokens.borderRadius.sm,
    "> svg": {
      display: "block",
    },
    ":hover": {
      color: designTokens.accent[600],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  block: {
    display: "flex",
    flexDirection: "column",
  },
  blockGroup: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    "> :first-child > :first-child": {
      paddingRight: designTokens.spacing[6],
    },
  },
  captionLabel: {
    color: designTokens.accent[700],
    fontSize: designTokens.fontSize.xxs,
    fontWeight: designTokens.fontWeight.semibold,
    letterSpacing: designTokens.letterSpacing.wide,
    textTransform: "uppercase",
    marginBottom: designTokens.spacing[1],
  },
  captionText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.primary[800],
    lineHeight: String(designTokens.lineHeight.normal),
    margin: "0",
  },
});
